
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-medical"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-medical"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
    </div>

    <div class="profile-photo-body">
      <div class="cannot-edit-profile" tabindex="0">
        <label class="medical-information"> Medical Information </label>
      </div>
      <div class="cannot-edit-profile-rectangle">
        <textarea sanitizeInputForm
      [ngClass]="{
        'max-character-error-box-error': dialogData.noLengthyCharacter
      }"
          [formControl]="dialogData.addMedicalFormControl"
          (input)="dialogData.onInput($event)"
          tabindex="0"
          rows="5"
          cols="50"
          maxlength="1000"
        ></textarea>
      </div>
      @if (dialogData.noLengthyCharacter) {
        <div
          role="alert"
          aria-label="error"
          tabindex="0"
          class="max-character-error"
          >
          <label>Maximum character limit reached</label>
        </div>
      }
      <div class="preferences-row checkbox">
        <input
          id="preferences-check"
          type="checkbox"
          [(ngModel)]="dialogData.checkMedicalConsent"
          [checked]="dialogData.checkMedicalConsent"
          (change)="dialogData.medicalConsentSelected($event)"
          />
          <label for="preferences-check" class="left-panel"> </label>
          <span class="please-tick-here-to">
            Please tick here to consent to this information being shared
            with your club and team coach who may incorporate it into the
            squad list when you are playing on match days.
          </span>
        </div>
        <div class="btn-container">
          <button
            tabindex="0"
            role="button"
            aria-label="save"
            class="send-button"
      [disabled]="
        !dialogData.addMedicalFormControl.valid || !dialogData.checkMedicalConsent
      "
            (click)="dialogData.saveMedicalDetails()"
            >
            Save
          </button>
        </div>
      </div>



    </div>
  </div>

